import styled from '@emotion/styled'

export const Wrapper = styled.div`
  overflow-x: auto;
  background-color: white;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;

  .standard-pagination .ant-pagination {
    margin-top: 20px;
    text-align: left;
  }

  .standard-pagination .ant-pagination-item,
  .standard-pagination .ant-pagination-jump-prev,
  .standard-pagination .ant-pagination-jump-next {
    min-width: 40px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #c4c4c4;
    border-radius: 50%;
    margin: 0 5px;
  }

  .standard-pagination .ant-pagination-prev,
  .standard-pagination .ant-pagination-next {
    min-width: 80px;
    width: auto;
    height: 40px;
    line-height: 40px;
    border: 1px solid #c4c4c4;
    border-radius: 30px;
    margin: 0 5px;
  }

  .standard-pagination .ant-pagination-disabled.ant-pagination-prev,
  .standard-pagination .ant-pagination-disabled.ant-pagination-next {
    display: none;
  }

  .standard-pagination .ant-pagination-prev,
  .standard-pagination .ant-pagination-next,
  .standard-pagination .ant-pagination-item-link,
  .standard-pagination .ant-pagination-jump-prev,
  .standard-pagination .ant-pagination-jump-next {
    color: black;
  }

  .standard-pagination .ant-pagination-item a,
  .standard-pagination .ant-pagination-item a:hover,
  .standard-pagination .ant-pagination-prev .ant-pagination-item-link,
  .standard-pagination .ant-pagination-next .ant-pagination-item-link,
  .standard-pagination .ant-pagination-jump-prev .ant-pagination-item-link,
  .standard-pagination .ant-pagination-jump-next .ant-pagination-item-link {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: ${({ theme }) => theme.text.pMini.fontSize};
    line-height: ${({ theme }) => theme.text.pMini.lineHeight};
    white-space: nowrap;
  }

  .standard-pagination .ant-pagination-prev .ant-pagination-item-link,
  .standard-pagination .ant-pagination-next .ant-pagination-item-link {
    box-sizing: border-box;
    padding: 0 14px;
  }

  .standard-pagination .ant-pagination-item-active,
  .standard-pagination .ant-pagination-item-active:hover {
    background: ${({ theme }) => theme.colors.main};
    color: ${({ theme }) => theme.colors.text.surface};
    border-color: ${({ theme }) => theme.colors.main};
  }

  .standard-pagination .ant-pagination-item-active a,
  .standard-pagination .ant-pagination-item-active a:hover {
    color: ${({ theme }) => theme.colors.text.surface};
  }

  .standard-pagination .ant-pagination-prev:hover,
  .standard-pagination .ant-pagination-next:hover,
  .standard-pagination .ant-pagination-item:hover,
  .standard-pagination .ant-pagination-jump-prev:hover,
  .standard-pagination .ant-pagination-jump-next:hover {
    background: ${({ theme }) => theme.colors.main};
    color: ${({ theme }) => theme.colors.text.surface};
    border-color: ${({ theme }) => theme.colors.main};
  }

  .standard-pagination .ant-pagination-prev:hover .ant-pagination-item-link,
  .standard-pagination .ant-pagination-next:hover .ant-pagination-item-link,
  .standard-pagination .ant-pagination-jump-prev:hover .ant-pagination-item-link,
  .standard-pagination .ant-pagination-jump-next:hover .ant-pagination-item-link {
    color: ${({ theme }) => theme.colors.text.surface};
  }

  .standard-pagination .ant-pagination-disabled,
  .standard-pagination .ant-pagination-disabled:hover {
    border-color: #c7c7c7;
  }

  .standard-pagination .ant-pagination-disabled .ant-pagination-item-link,
  .standard-pagination .ant-pagination-disabled:hover .ant-pagination-item-link {
    color: #c7c7c7;
    background: transparent;
  }
`
